/**
 * 判断数字参数是否有值
 */
function checkNum(num) {
    return Boolean(num || num === 0);
}

/**
 * 格式化定位
 * @param style 样式对象
 * @param position 定位key (top bottom left right) , 数值为375px标准下的尺寸
 */
export function formatPositionStyle(style = {}, position = {}) {
    Object.keys(position).forEach((key) => {
        if (checkNum(position[key])) {
            style[key] = `${((position[key] / 375) * 100).toFixed(2)}vw`;
        }
    });
    return style;
}
